export default __webpack_public_path__ + "static/media/sp-dropdown.7c54d3a2.webp";